<template>
  <div class="sa-donation-list__footer">
    <p class="sa-donation-list__footer-note">
      <router-link :to="{ name: 'Donations' }" class="sa-donation-list__footer-link">
        {{ $t('Dashboard.Home.ViewGivingRecordCta') }}
      </router-link>
    </p>
  </div>
</template>
